<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">

    <div class="row">
      <div class="col px-0">
        <div class="select_container" style="float:left;">
          <select class="form-control" v-bind:id="'select_' + getId()" v-bind="value" data-fouc v-on:change="onChange"  v-select>
            <option value="" style="">{{placeholder}}</option>
            <option v-for="option in contacts" v-bind:value="option.ContactId">
              {{ option.FirstName }} {{ option.LastName }} {{ option.Email }}
            </option>
          </select>
        </div>
        <button type="button" class="btn btn-outline skin primary-button btn-icon ml-1" @click="displayForm" style="float:right;"><i class="icon-user-plus"></i></button>

      </div>
    </div>

    <div class="row" v-if="displayAdd == true">
      <div class="col-md-6 pl-0">
        <input type="text" v-bind:placeholder="$t('first_name')" class="form-control" v-model="firstname">
      </div>

      <div class="col-md-6 pr-0">
        <input type="text" v-bind:placeholder="$t('last_name')" class="form-control" v-model="lastname">
      </div>

    </div>
    <div class="row" v-if="displayAdd == true">
      <div class="col-12 col-md-10 px-0">
        <input type="text" v-bind:placeholder="$t('email')" class="form-control" v-model="contactemail">
      </div>
      <div class="text-right col-12 col-md-10  px-0" v-if="displayAdd == true">
        <button type="submit" class="btn skin btn-primary mt-1 col-12 col-md-2 btn-sm" @click="createContact">{{buttontext}}</button>
      </div>
    </div>

    

    <div v-if="message != null && message != ''" class="col-12 alert alert-light upload-error-message" role="alert">
      <ul>
        <li class="col-12" v-for="(ms, i) in message.split('\n')" :key="i">
          {{ ms }}
        </li>
      </ul>
    </div>

  </div>
</template>

<script>


  let message = "";
  let displayAdd = false;
  var contacts = [];
  var contactemail = "";
  var firstname = "";
  var lastname = "";
  var placeholder = "";
  var buttontext = "";

  export default {
    name: "select-contact",
    props: {
      value: {
        type: String,
        default: null
      },
    },
    data() {
      return {
        firstname,
        lastname,
        message: "",
        visible: this.visibility,
        displayAdd,
        contacts,
        contactemail,
        buttontext,
        placeholder
      };
    },
    methods: {
      displayForm() {
        this.displayAdd = !this.displayAdd;
      },
      getOptionStyle(v) {
        return v;
      },
      onChange() {
        this.$emit('change', $('#select_' + this.getId()).val());
      },
      getId() {
        return this._uid;
      },
      doChange() {
      },
      async createContact() {
        var request = { firstname: this.firstname, lastname: this.lastname, email: this.contactemail };
        try {
          var response = await this.$http.post(
            '/api/Contacts/v1/Create',
            request
          ).then(async response => {
            this.loadContacts(response.data.Id);
            this.displayAdd = false;
          });

        } catch (err) {
          alert(err);
        }
      },
      async loadContacts(selected) {
        try {
          this.contacts = [];
          this.$http.get('/api/Contacts/v1/Search?').then(async response => {
            
            this.contacts = response.data;
            $('#' + 'select_' + this.getId()).select2();
          }).then((async response => {
            if (selected != null) {
              $("#select_" + this.getId()).val(selected);
              $("#select_" + this.getId()).trigger('change');
            }
          }
          ));
        } catch (err) {
          alert('some error:' + err)
        }
      },
      getData() {
        return this.contacts;
      }
    },
    watch: {
      value: function (newVal, oldVal) {
        $("#select_" + this.getId()).val(newVal);
        $("#select_" + this.getId()).trigger('change');
      }
    },
    mounted() {
      this.loadContacts(this.value);
      $("#select_" + this.getId()).change(this.onChange);
      this.placeholder = this.$t('select_contact');
      this.buttontext = this.$t('add_contact');
    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>
  



// WEBPACK FOOTER //
// src/components/contact/contact-selector.vue